const getLocalStorageKey = (artistId: string, releaseId: string) => `RELEASE.${artistId}.${ releaseId }.LAST_LOCATION`

export const setLastLocation = (artistId: string, releaseId: string, location: string) => {
  if (location.endsWith('checkout')) {
    return;
  }
  localStorage.setItem(getLocalStorageKey(artistId, releaseId), location);
}

export const getLastLocation = (artistId: string, releaseId: string) => {
  const defaultPath = `/release/${artistId}/${releaseId}/title`;

  const location = localStorage.getItem(getLocalStorageKey(artistId, releaseId));

  if (location?.endsWith('checkout')) {
    return defaultPath;
  }

  return location || defaultPath;
}